module.exports = __webpack_public_path__ + "static/media/agency.210fdb23.mp4";